import Vue from 'vue'
import VueSilentbox from 'vue-silentbox'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import Quiz from '../components/Quiz'
import Results from '../components/Results'
import Cookies from '../components/Cookies'
import GeneralConditions from '../components/GeneralConditions'
import database from '../components/firebaseInit'

// A reference to the users collection.
const users = database.collection('users');

Vue.use(VueRouter);
Vue.use(VueSilentbox);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/start-test',
      name: 'Quiz',
      component: Quiz,
      props: (route) => ({
        debug: route.query.debug,
        step: route.query.step,
        grade: route.query.grade,
        email: route.query.email,
      })
    },
    {
      path: '/results/:uid',
      name: 'Results',
      component: Results,
      beforeEnter: (to, from, next) => {
        const docRef = users.doc(to.params.uid);
        docRef.get().then((documentSnapshot) => {
          if (documentSnapshot.exists) {
            to.params.myCustomizations = {};
            next()
          } else {
            console.log('No such document!');
            next({ path: '/'})
          }
        })
      }
    },
    {
      path: '/cookies',
      name: 'Cookies',
      component: Cookies
    },
    {
      path: '/general-conditions',
      name: 'GeneralConditions',
      component: GeneralConditions
    },
    {
      path: '*',
      redirect: '/',
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js